var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/verification/email-passthru.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import snackbar from 'soapbox/actions/snackbar';
import { confirmEmailVerification } from 'soapbox/actions/verification';
import { Icon, Spinner, Stack, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import { ChallengeTypes } from './index';
const Statuses = {
  IDLE: 'IDLE',
  SUCCESS: 'SUCCESS',
  GENERIC_FAIL: 'GENERIC_FAIL',
  TOKEN_NOT_FOUND: 'TOKEN_NOT_FOUND',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED'
};
const messages = defineMessages({
  emailConfirmedHeading: {
    "id": "email_passthru.confirmed.heading",
    "defaultMessage": "Email Confirmed!"
  },
  emailConfirmedBody: {
    "id": "email_passthru.confirmed.body",
    "defaultMessage": "Close this tab and continue the registration process on the {bold} from which you sent this email confirmation."
  },
  genericFailHeading: {
    "id": "email_passthru.generic_fail.heading",
    "defaultMessage": "Something Went Wrong"
  },
  genericFailBody: {
    "id": "email_passthru.generic_fail.body",
    "defaultMessage": "Please request a new email confirmation."
  },
  tokenNotFoundHeading: {
    "id": "email_passthru.token_not_found.heading",
    "defaultMessage": "Invalid Token"
  },
  tokenNotFoundBody: {
    "id": "email_passthru.token_not_found.body",
    "defaultMessage": "Your email token was not found. Please request a new email confirmation from the {bold} from which you sent this email confirmation."
  },
  tokenExpiredHeading: {
    "id": "email_passthru.token_expired.heading",
    "defaultMessage": "Token Expired"
  },
  tokenExpiredBody: {
    "id": "email_passthru.token_expired.body",
    "defaultMessage": "Your email token has expired. Please request a new email confirmation from the {bold} from which you sent this email confirmation."
  },
  emailConfirmed: {
    "id": "email_passthru.success",
    "defaultMessage": "Your email has been verified!"
  },
  genericFail: {
    "id": "email_passthru.fail.generic",
    "defaultMessage": "Unable to confirm your email"
  },
  tokenExpired: {
    "id": "email_passthru.fail.expired",
    "defaultMessage": "Your email token has expired"
  },
  tokenNotFound: {
    "id": "email_passthru.fail.not_found",
    "defaultMessage": "Your email token is invalid."
  },
  invalidToken: {
    "id": "email_passthru.fail.invalid_token",
    "defaultMessage": "Your token is invalid"
  }
});

const Success = () => {
  const intl = useIntl();
  const history = useHistory();
  const currentChallenge = useAppSelector(state => state.verification.currentChallenge); // Bypass the user straight to the next step.

  if (currentChallenge === ChallengeTypes.SMS) {
    history.push('/verify');
    return null;
  }

  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-check.svg'),
    className: "text-primary-600 dark:text-primary-400 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.emailConfirmedHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.emailConfirmedBody, {
    bold: /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      weight: "medium",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 66
      }
    }, "same device")
  })));
};

const GenericFail = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-x.svg'),
    className: "text-danger-600 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.genericFailHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.genericFailBody)));
};

const TokenNotFound = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-x.svg'),
    className: "text-danger-600 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenNotFoundHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenNotFoundBody, {
    bold: /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      weight: "medium",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 65
      }
    }, "same device")
  })));
};

const TokenExpired = () => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-x.svg'),
    className: "text-danger-600 h-10 w-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Text, {
    size: "3xl",
    weight: "semibold",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenExpiredHeading)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 7
    }
  }, intl.formatMessage(messages.tokenExpiredBody, {
    bold: /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      weight: "medium",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 64
      }
    }, "same device")
  })));
};

const EmailPassThru = () => {
  const {
    token
  } = useParams();
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const [status, setStatus] = React.useState(Statuses.IDLE);
  React.useEffect(() => {
    if (token) {
      dispatch(confirmEmailVerification(token)).then(() => {
        setStatus(Statuses.SUCCESS);
        dispatch(snackbar.success(intl.formatMessage(messages.emailConfirmed)));
      }).catch(error => {
        var _error$response, _error$response$data;

        const errorKey = error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error;
        let message = intl.formatMessage(messages.genericFail);

        if (errorKey) {
          switch (errorKey) {
            case 'token_expired':
              message = intl.formatMessage(messages.tokenExpired);
              setStatus(Statuses.TOKEN_EXPIRED);
              break;

            case 'token_not_found':
              message = intl.formatMessage(messages.tokenNotFound);
              message = intl.formatMessage(messages.invalidToken);
              setStatus(Statuses.TOKEN_NOT_FOUND);
              break;

            default:
              setStatus(Statuses.GENERIC_FAIL);
              break;
          }
        }

        dispatch(snackbar.error(message));
      });
    }
  }, [token]);

  switch (status) {
    case Statuses.SUCCESS:
      return /*#__PURE__*/React.createElement(Success, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154,
          columnNumber: 14
        }
      });

    case Statuses.TOKEN_EXPIRED:
      return /*#__PURE__*/React.createElement(TokenExpired, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 14
        }
      });

    case Statuses.TOKEN_NOT_FOUND:
      return /*#__PURE__*/React.createElement(TokenNotFound, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 14
        }
      });

    case Statuses.GENERIC_FAIL:
      return /*#__PURE__*/React.createElement(GenericFail, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 14
        }
      });

    default:
      return /*#__PURE__*/React.createElement(Spinner, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 14
        }
      });
  }
};

export default EmailPassThru;